import { FC } from "react";
import { BuscarComponent } from "../../../../shared/providers/ListView/BuscarComponent";
import { AuditoriaSesionHeaderToolbar } from "./AuditoriaSesionHeaderToolbar";

export const AuditoriaSesionHeader: FC = () => {
    
    return (
        <div className='card-header border-0 py-4'>
            <BuscarComponent placeholder="Buscar" />
            <div className='card-toolbar'>
                <AuditoriaSesionHeaderToolbar />
            </div>
        </div>
    )
}